export const getSettlementStatusLabel = (status?: string): string => {
    const labels: Record<string, string> = {
        created: 'در انتظار پرداخت',
        send_shaparak: 'ارسال برای شاپرک',
        accepted: 'واریز شده',
        rejected: 'لغو شده',
    };

    return labels[status || ''] ?? String(status || '');
};
